/**
 * Check overall cookies weight and reset them when maxLength is reached.
 *
 * Most browser support 50 cookies per domain, and don't exceed 4093 bytes per domain
 * (i.e. total size of all cookies <= 4093 bytes)
 *
 * @todo Complete white-listed cookies description
 *
 * @see also FnacDirect.Technical.Framework.Web.Helper.ClearAllCookies.ImportantCookiesRegex
 */
import { cookiesHostname, cookiesPath } from '../../../Assets/javascripts/common/others/Configuration';
import Cookies from 'js-cookie';

const maxLength = 12800;
const whiteList = [
  '.AUTH', // Back-end : Authentication
  // "AMCV_###@AdobeOrg",    // Adobe Tag Commander : ?
  'campaign', // Adobe Tag Commander : ?
  'identityImpersonator', // Back-end: see the property webSiteConfig.identityImpersonator.cookieName, https://support.microsoft.com/en-us/help/306158/how-to-implement-impersonation-in-an-asp-net-application
  // we temporary disable LSI whitelisting cuz it's fuckin too large bro
  // "LSI",               // Back-end : Last seen item
  'NBART', // Back-end : Basket items counter
  'OrderInSession', // Traffic acquisition : ?
  'ORGN', // Traffic acquisition : ?
  'ORGN_DTLS', // Traffic acquisition : ?
  // "t2s-p",             // Traffic acquisition : target2sell.com
  'eb-profile', // Traffic acquisition : Earlybirds
  's_cc', // Adobe Analytics : If cookies are enabled https://marketing.adobe.com/resources/help/en_US/whitepapers/cookies/cookies_analytics.html#concept_98805569FE284595B34A7684647D7C71__section_03AA90AA7E36427B8CB12DC4A0F0291E
  's_fid', // Adobe Analytics : Fallback unique visitor ID time/date stamp https://marketing.adobe.com/resources/help/en_US/whitepapers/cookies/cookies_analytics.html#concept_98805569FE284595B34A7684647D7C71__section_65E33F9BFC264959AC1513E2F4B10AC7
  's_sq', // Adobe Analytics : Information about the previous link that was clicked on by the user https://marketing.adobe.com/resources/help/en_US/whitepapers/cookies/cookies_analytics.html#concept_98805569FE284595B34A7684647D7C71__section_8ABFFF3A302D494F81A3CFB91E3B09FF
  's_vi', // Adobe Analytics : Unique visitor ID time/date stamp https://marketing.adobe.com/resources/help/en_US/whitepapers/cookies/cookies_analytics.html#concept_98805569FE284595B34A7684647D7C71__section_5D50A078DE444D12B7D927D68FF3B679
  'SID', // Back-end : Session ID
  //"TEST_R",               // Retargeting : Eulerian Technologies (via Adobe Analytics)
  'UID', // Back-end : User ID
  'kvn', // A/B Search
  'datadome', // Datadome (antibot protection)
  'cnil', // Device tracking for transactions security $/10-Front/Services/Checkout/Dev/Dev-Front/src/orderpipe/Steps/Business/Base/Purchase/AddDeviceInfos.cs
  'akavpau_FRPRD_FNACCOM', // Akamaï (waiting room), session?

  'OptanonConsent', // OneTrust - Consent Management Platforms (CMP)
  'OptanonAlertBoxClosed', // OneTrust - Consent Management Platforms (CMP)
  'consentNoticeClosed', // consent notice (when there is no CMP)

  // Kameleoon backoffice (editor)
  'kameleoonSessionId',
  'kameleoonAuthenticationData',
  'kameleoonVisitorCode',
  'account_review_article', // AB Test review article

  'eupubconsent-v2', // https://cookiedatabase.org/cookie/iab-tcf/eupubconsent-v2/

  'VID', // Back-end : Visit ID
  '_cs_id', // Content Square

  //Preconisation botmanager
  'ak_bmsc',
  'bm_mi',
  'bm_sv',
  'bm_sz',
  '_abck',
];

/**
 * Remove all the cookies with the exception of white-listed ones
 */
export default function () {
  const cookies = Object.keys(Cookies.get());

  if (document.cookie.length < maxLength && cookies.length < 150) {
    return;
  }

  const removableCookies = cookies.filter((name) => !whiteList.includes(name));

  console.warn('Cookies data is too large (' + maxLength + ' bytes), auto remove: ' + removableCookies.join(', '));

  removableCookies.forEach((name) => {
    Cookies.remove(name, {
      domain: cookiesHostname,
      path: cookiesPath,
    });

    Cookies.remove(name, {
      domain: document.location.host,
      path: document.location.pathname,
    });
  });
}
